<template>
    <main class="row content__page">
      <section class="column large-full entry format-standard">
        <div class="content__page-header">
          <h1>
            <i class="fa fa-envelope" aria-hidden="true"></i> {{ $t('contact.get_in_touch') }}
          </h1>
        </div>
  
        <h4>
          {{ $t('contact.intro_message') }}
        </h4>
  
        <table class="contact-table">
          <tbody>
            <tr>
              <th colspan="2">{{ $t('contact.united_states') }}</th>
            </tr>
            <tr>
              <td style="width:200px;">{{ $t('contact.address') }}</td>
              <td>95 3rd St 2nd Floor, San Francisco, CA 94103</td>
            </tr>
            <tr>
              <td>{{ $t('contact.email') }}</td>
              <td><a href="mailto:news@enov.group">news@enov.group</a></td>
            </tr>
            <tr>
              <td>{{ $t('contact.phone') }}</td>
              <td>+1-415-707-2770</td>
            </tr>
          </tbody>
        </table>
<!--   
        <table class="contact-table">
          <tbody>
            <tr>
              <th colspan="2">{{ $t('contact.ivory_coast') }}</th>
            </tr>
            <tr>
              <td style="width:200px;">{{ $t('contact.address') }}</td>
              <td>25 BP 486 Abidjan 25</td>
            </tr>
            <tr>
              <td>{{ $t('contact.phone') }}</td>
              <td>+225-02-886-886</td>
            </tr>
          </tbody>
        </table>
-->
        <p>
          {{ $t('contact.parent_company_message') }} <a href="https://enov.group/contact" target="_blank">ENOV Group</a>.
        </p>
  
      </section>
    </main>
  </template>
  
  <script>
  export default {
    name: 'ContactPage',
  };
  </script>
  
  <style scoped>
  .contact-table {
    font-size: 14px;
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .contact-table th,
  .contact-table td {
    border: 1px solid #ddd;
    padding: 8px;
  }
  
  .contact-table th {
    background-color: #f4f4f4;
    text-align: left;
  }
  
  .contact-table td {
    background-color: #fff;
  }
  </style>
